import React, { useState, useEffect } from "react";
import {
  Typography,
  Button,
  Icon,
  IconButton,
  makeStyles,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  Paper,
  TableHead,
  TableRow,
  Grid,
} from "@material-ui/core";

import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import CreateIcon from "@material-ui/icons/Create";
import Loader from "../../components/Loader";
import RemoveIcon from "@material-ui/icons/Remove";
import * as moment from "moment";
import {
  PROJECT,
  ASSIGN_VILLAGES,
  ADD_FIELD_SUPER_VISOR,
  ASSIGN_SECTOR_OFFICER,
  FARMS,
  VILLAGES,
  USERS,
  SUB_DISTRICTS,
  ADD_VILLAGES,
  TEAMS,
  FARMERS,
} from "../../configs/urls";
import { MESSAGES } from "../../configs/messages";
import { getApi, postApi, putApi } from "../../services/api";
import { DATE_FORMATS } from "../../configs/constant";
import VisibilityIcon from "@material-ui/icons/Visibility";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import { ROLES } from "../../configs/constant";
import axios from "axios";
import FormControl from "@material-ui/core/FormControl";
import InputLabel from "@material-ui/core/InputLabel";
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";
import { Multiselect } from "multiselect-react-dropdown";
import Slide from "@material-ui/core/Slide";
import { useHistory } from "react-router-dom";
import Divider from "@material-ui/core/Divider";
import DialogContentText from "@material-ui/core/DialogContentText";
import Toaster from "../../components/Toaster";
import ViewSectorOfficer from "../../components/SectorOfficer/viewSectorOffice";

const multiselectStyle = {
  searchBox: {
    minHeight: "40px",
    marginTop: 19,
    border: "none",
    borderBottom: "1px solid #2b7b56",
  },
};

const multiselectStyleWithWidth = {
  searchBox: {
    width: "400px",
    minHeight: "40px",
    marginTop: 19,
    border: "none",
    borderBottom: "1px solid #2b7b56",
  },
};

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="down" ref={ref} {...props} />;
});

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    maxWidth: 752,
    minWidth: "100%",
    margin: "auto",
  },
  demo: {
    backgroundColor: theme.palette.background.paper,
    borderRadius: 10,
    padding: 30,
  },
  title: {
    margin: theme.spacing(4, 0, 2),
  },
  singleSelect: {
    width: "250px",
    marginTop: 19,
  },
  singleSelectAddField: {
    width: "360px",
    marginTop: 19,
  },
  singleSelectNormalWidth: {
    width: "180px",
    marginTop: 19,
  },
  marginTop5: {
    marginTop: 5,
  },
  marginLeft: {
    marginLeft: 10,
  },
  marginTop25: {
    marginTop: 25,
  },
  disable: {
    pointerEvents: "none",
    opacity: 0.5,
  },
  value: {
    marginLeft: 7,
    textTransform: "capitalize",
    color: "#000",
    fontSize: 14,
  },
  label: {
    fontSize: 15,
    fontWeight: "normal",
    color: "#444",
  },
  fieldSuperVisorLabel: {
    fontSize: 15,
    fontWeight: "normal",
    color: "#444",
    textTransform: "uppercase",
  },
  labelParent: {
    marginTop: 10,
  },
  colorBox: {
    float: "right",
  },
  coloInnexBox: {
    height: 15,
    width: 15,
    display: "inline-block",
    borderRadius: "50%",
    verticalAlign: "sub",
    marginLeft: 10,
  },
  fieldSuperVisorButton: {
    fontSize: 11,
    paddingLeft: 8,
    paddingRight: 8,
    paddingTop: 3,
    paddingBottom: 3,
    marginLeft: 6,
  },
  pending: {
    background: "red",
  },
  inprocess: {
    background: "blue",
  },
  completed: {
    background: "green",
  },
  colorLabel: {
    fontSize: 13,
    marginLeft: 3,
    textTransform: "uppercase",
    fontWeight: "bold",
  },
  fieldSupervisorsTitle: {
    fontSize: 20,
    fontWeight: "bold",
    color: "#777",
    display: "inline",
    textTransform: "uppercase",
  },
  projectTitle: {
    fontSize: 20,
    fontWeight: "bold",
    textTransform: "uppercase",
  },
  floatRight: {
    float: "right !important",
  },
  tableMainContainer: {
    backgroundColor: "#eee",
    marginTop: 25,
  },
  tableData: {
    borderLeft: "1px solid #ddd",
    borderBottom: "1px solid #ddd",
    minWidth: "150px",
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
  },
  upperTableWidth: {
    width: "124px",
  },
  cursorPointer: {
    cursor: "pointer",
  },
  fullWidth: {
    width: "100% !important",
  },
}));

export default function ViewProject(props) {
  const classes = useStyles();
  const [project, setProjectData] = useState(null);
  const [isRequesting, setIsRequestig] = useState(false);
  const [params, setParams] = useState({ page: 0 });
  // const [totalprojectsCount, setTotalprojectsCount] = useState(0)
  const [
    isAddFieldSuperVisorDialogOpen,
    setIsAddFieldSuperVisorDialogOpen,
  ] = useState(false);
  const [isReAssignDialogOpen, setIsReAssignDialogOpen] = useState(false);

  const [isAddVillageDialogOpen, setIsAddVillageDialogOpen] = useState(false);

  const [assignFieldOfficerData, setAssignFieldOfficerData] = useState({
    isDialogOpen: false,
    sector_officers: [],
    sectorOfficerList: [],
  });

  const [fieldSupervisorsData, setFieldSupervisorsData] = useState([]);
  const [villagesList, setVillagesList] = useState([]);

  const [usersList, setUsersList] = useState([]);
  const [selectedFieldSuperVisor, setSelectedFieldSuperVisor] = useState([]);
  const [teamListing, setTeamListing] = useState([]);
  const [reassignVillagesData, setReassignVillagesData] = useState({
    field_supervisor_id: "",
    villages: [],
    project_id: "",
  });

  const [addVillagesData, setAddVillageData] = useState({
    field_supervisor_id: "",
    villages: [],
    project_id: "",
    sub_district_id: "",
  });

  const [confirmDailogeBoxData, setConfirmDailogeBoxData] = useState({
    isOpen: false,
    selectedIndex: null,
  });

  const [viewSectorOfficerData, setViewSectorOfficerData] = useState({
    isDialogOpen: false,
    sectorOfficerList: [],
  });

  const [subDistrictList, setSubDistrictList] = useState([]);

  const history = useHistory();

  useEffect(() => {
    fetchProject(true);
  }, []); //eslint-disable-line

  const fetchProject = (isInitialLoad, isAddFieldSuper) => {
    setIsRequestig(true);
    const users = getApi(USERS, {
      role: ROLES.FIELD_SUPERVISOR,
      idle_users: true,
    });

    const project = getApi(PROJECT + "/" + props.match.params.project_id);

    const sectorOfiicer = getApi(USERS, { role: ROLES.SECTOR_OFFICER });
    const farmer = getApi(FARMERS, {
      is_team_assigned: 0,
      project_id: props.match.params.project_id,
    });
    axios
      .all([users, project, sectorOfiicer, farmer])
      .then((res) => {
        setUsersList(res[0].data);
        let project = res[1].data;
        project.maxVillage = [];
        project.field_supervisors_villages = [];

        project.field_supervisors.forEach((user) => {
          if (project.maxVillage.length < user.villages.length)
            project.maxVillage.length = user.villages.length;
          user.field_supervisors_villages = [];
        });

        for (var i = 0; i <= project.maxVillage.length - 1; i++) {
          project.maxVillage[i] = Math.random();
        }

        for (var i = 0; i <= project.maxVillage.length; i++) {
          project.field_supervisors.forEach((user) => {
            user.field_supervisors_villages.push(user.villages[i] || {});
          });
        }

        setProjectData(project);

        let projectData = res[1].data;
        setIsRequestig(true);
        const district_id =
          projectData?.project_district?.map((dist) => dist.district_id) || [];
        getApi(SUB_DISTRICTS, { district_id: district_id })
          .then(
            (res) => {
              setSubDistrictList(res.data);
            },
            (err) => {
              console.log(err);
            }
          )
          .finally(() => {
            setIsRequestig(false);
          });

        setAssignFieldOfficerData({
          ...assignFieldOfficerData,
          sectorOfficerList: res[2].data,
        });
        setViewSectorOfficerData({
          ...viewSectorOfficerData,
          sectorOfficerList: projectData.sector_officers,
        });
        if (isAddFieldSuper && res[3]?.data) {
          let farmerData = res[3]?.data;
          const farmerDataWithTeamId = [];
          if (teamListing && teamListing.length) {
            // teamListing.map((team) => {
            farmerData.map((farmer) => {
              const team = teamListing.find((teamItem) =>
                teamItem.team_village.some(
                  (villageItem) =>
                    villageItem.village_id === farmer.village_id &&
                    villageItem.village.district_id === farmer.district_id
                )
              );
              // const isTeamVillage = team.team_village.some(
              //   (village) => village.village_id === farmer.village_id
              // );
              if (team && team.id) {
                farmerDataWithTeamId.push({
                  id: farmer.id,
                  team_id: team.id,
                });
              }
            });
            // });
            // debugger;
            updateFarmers(farmerDataWithTeamId);
          }
        }
      })
      .finally(() => {
        setIsRequestig(false);
      });
  };

  const updateFarmers = (data) => {
    data.forEach((farmerData) => {
      const formData = new FormData();

      for (const key in farmerData) {
        formData.append(key, farmerData[key]);
      }

      putApi(FARMERS, formData)
        .then(
          (res) => {
            // getproject();
          },
          (err) => {
            console.log(err);
          }
        )
        .finally(() => {
          setIsRequestig(false);
        });
    });
  };

  const handleConfirmDailogBoxClose = (action) => {
    let items = [...fieldSupervisorsData];

    if (action == "delete") {
      items.splice(confirmDailogeBoxData.selectedIndex, 1);
    }

    setConfirmDailogeBoxData({
      isOpen: false,
      selectedIndex: null,
    });
    setFieldSupervisorsData(items);
  };

  const closeViewSectorOfficerDailog = (action, selectedOfficer) => {
    switch (action) {
      case "create_team":
        getApi(FARMS, { project_id: project.id, is_team_assigned: 0 }).then(
          (res) => {
            if (res.data.length > 0) {
              history.push(
                "/admin/teams/operations/create/" +
                  project.id +
                  "/" +
                  selectedOfficer.sector_officer_id
              );
            } else {
              Toaster.showWarning("There is no farmer to create team");
            }
          }
        );

        break;
      case "view_team":
        history.push(
          "/admin/teams/" + project.id + "/" + selectedOfficer.sector_officer_id
        );
        break;
      case "close":
        setViewSectorOfficerData({
          ...viewSectorOfficerData,
          isDialogOpen: false,
        });
        break;
    }
  };

  const getproject = () => {
    setIsRequestig(true);

    const project = getApi(
      PROJECT + "/" + props.match.params.project_id,
      params
    )
      .then(
        (res) => {
          let project = res.data;
          project.maxVillage = [];
          project.field_supervisors_villages = [];

          project.field_supervisors.forEach((user) => {
            if (project.maxVillage.length < user.villages.length)
              project.maxVillage.length = user.villages.length;
            user.field_supervisors_villages = [];
          });

          for (var i = 0; i <= project.maxVillage.length - 1; i++) {
            project.maxVillage[i] = Math.random();
          }

          for (var i = 0; i <= project.maxVillage.length; i++) {
            project.field_supervisors.forEach((user) => {
              user.field_supervisors_villages.push(user.villages[i] || {});
            });
          }

          setProjectData(project);

          setViewSectorOfficerData({
            ...viewSectorOfficerData,
            sectorOfficerList: project.sector_officers,
          });
        },
        (err) => {
          console.log(err);
        }
      )
      .finally(() => {
        setIsRequestig(false);
      });
  };

  const selectSubDistrict = (subDistricts) => {
    var subDistrictIds = [];

    subDistricts.forEach((item) => {
      subDistrictIds.push(item.id);
    });

    setVillagesList([]);

    setIsRequestig(true);
    const districtId = project.project_district.map(
      (district) => district.district_id
    );
    getApi(VILLAGES, {
      district_id: districtId,
      sub_district_ids: subDistrictIds,
    })
      .then(
        (res) => {
          setVillagesList(res.data || []);
        },
        (err) => {
          console.log(err);
        }
      )
      .finally(() => {
        setIsRequestig(false);
      });
  };

  const getVillages = (district_id, sub_district_id) => {
    setVillagesList([]);

    setIsRequestig(true);

    getApi(VILLAGES, { district_id, sub_district_id })
      .then(
        (res) => {
          setVillagesList(res.data || []);
        },
        (err) => {
          console.log(err);
        }
      )
      .finally(() => {
        setIsRequestig(false);
      });
  };

  const getTeams = () => {
    setTeamListing([]);

    setIsRequestig(true);

    getApi(TEAMS, { project_id: project.id })
      .then(
        (res) => {
          setTeamListing(res.data || []);
        },
        (err) => {
          console.log(err);
        }
      )
      .finally(() => {
        setIsRequestig(false);
      });
  };

  const addRemoveFieldFromFieldSuperVisorData = (action, idx) => {
    let items = [...fieldSupervisorsData];

    if (action == "add") {
      items.push({
        id: "",
        sub_district_id: "",
        villages: [],
        disable: false,
      });
    } else {
      setConfirmDailogeBoxData({
        isOpen: true,
        selectedIndex: idx,
      });
    }

    setFieldSupervisorsData(items);
  };

  const closeFieldSuperVisorDailogBox = (action) => {
    if (action == "close") setIsAddFieldSuperVisorDialogOpen(false);
    if (action == "add") addFieldSuperVisor();
  };

  const closeAssignSectorOfficerDailogBox = (action) => {
    if (action == "close")
      setAssignFieldOfficerData({
        ...assignFieldOfficerData,
        isDialogOpen: false,
      });
    if (action == "add") assignSectorOfficer();
  };

  const openAssignSectorOfficerDailoge = () => {
    if (
      project &&
      project.sector_officers.length ==
        assignFieldOfficerData.sectorOfficerList.length
    ) {
      Toaster.showWarning("No sector officer left.");
      return;
    }
    setAssignFieldOfficerData({
      ...assignFieldOfficerData,
      isDialogOpen: true,
    });
  };

  const assignSectorOfficer = () => {
    setIsRequestig(true);
    let sectorOfficerIds = [];
    let params = {
      project_id: project.id,
      sector_officers: [],
    };

    assignFieldOfficerData.sector_officers.map((user) => {
      params.sector_officers.push(user.id);
    });

    postApi(ASSIGN_SECTOR_OFFICER, params)
      .then(
        (res) => {
          setAssignFieldOfficerData({
            ...assignFieldOfficerData,
            isDialogOpen: false,
            sector_officers: [],
          });
          getproject();
        },
        (err) => {
          console.log(err);
        }
      )
      .finally(() => {
        setIsRequestig(false);
      });
  };

  const closeReassginDailogBox = (action) => {
    if (action == "close") setIsReAssignDialogOpen(false);
    if (action == "add") {
      if (!reassignVillagesData.field_supervisor_id) {
        alert(MESSAGES.PLEASE_SELECT_REASSIGN_USER);
        return;
      }

      if (reassignVillagesData.villages.length == 0) {
        alert(MESSAGES.PLEASE_SELECT_VILLAGES);
        return;
      }
      reAssignVillages();
    }
  };

  const closeAddVillageDailogBox = (action) => {
    if (action == "close") setIsAddVillageDialogOpen(false);
    if (action == "add") {
      if (!addVillagesData.field_supervisor_id) {
        alert(MESSAGES.PLEASE_SELECT_REASSIGN_USER);
        return;
      }

      if (addVillagesData.villages.length == 0) {
        alert(MESSAGES.PLEASE_SELECT_VILLAGES);
        return;
      }

      addVillages();
    }
  };

  const getDynamicUserList = (
    list,
    currentSelectedList,
    currentSelectedUserId
  ) => {
    let updatedUserList = [];
    let userIds = [];
    let selectedData = [];

    project.field_supervisors.forEach((fieldSupervisor) => {
      let userId = "";
      if (fieldSupervisor.user_details && fieldSupervisor.user_details.id) {
        userIds.push(fieldSupervisor.user_details.id);
      }
    });

    currentSelectedList.forEach((value, key) => {
      userIds.push(value.id);
    });

    list.forEach((user, key) => {
      if (userIds.indexOf(user.id) == -1) {
        updatedUserList.push(user);
      } else {
        if (user.id == currentSelectedUserId) {
          updatedUserList.push(user);
        }
      }
    });

    return updatedUserList;
  };

  const getDynamicVillageList = (
    list,
    currentSelectedList,
    currentSelectedVillageIds
  ) => {
    let updatedVillageList = [];
    let villageIds = [];
    let selectedVillages = [];

    if (project && project.field_supervisors.length > 0) {
      project.field_supervisors.forEach((fieldSupervisor) => {
        if (fieldSupervisor.villages.length > 0) {
          fieldSupervisor.villages.forEach((village) => {
            villageIds.push(village.village.id);
          });
        }
      });
    }

    currentSelectedList.forEach((fieldSupervisor, idx) => {
      currentSelectedList[idx].villages.forEach((value, key) => {
        villageIds.push(value.id);
      });
    });

    list.forEach((village, key) => {
      if (villageIds.indexOf(village.id) == -1) {
        updatedVillageList.push(village);
      } else {
        if (currentSelectedVillageIds.indexOf(village) != -1) {
          updatedVillageList.push(village);
        }
      }
    });

    return updatedVillageList;
  };

  const handleUserChange = (e, idx) => {
    let items = [...fieldSupervisorsData];

    let item = { ...items[idx] };

    item.id = e.target.value;

    items[idx] = item;

    setFieldSupervisorsData(items);
  };

  const handleAddFieldSuperVisorSubDistrictChange = (e, idx) => {
    let items = [...fieldSupervisorsData];

    let item = { ...items[idx] };

    item.sub_district_id = e.target.value;

    items[idx] = item;

    setFieldSupervisorsData(items);

    getVillages(project.district_id, e.target.value);
  };

  const handleVillagesChange = (list, idx) => {
    let items = [...fieldSupervisorsData];

    let item = { ...items[idx] };

    item.villages = list;

    items[idx] = item;

    setFieldSupervisorsData(items);
  };

  const setInitialFieldSuperVisorData = () => {
    const items = [
      {
        id: "",
        sub_district_id: "",
        villages: [],
      },
    ];

    setFieldSupervisorsData(items);
  };

  const reAssignVillages = () => {
    setIsRequestig(true);
    let villageIds = [];
    let params = reassignVillagesData;
    params.project_id = project.id;

    reassignVillagesData.villages.map((village) => {
      villageIds.push(village.id);
    });

    params.villages = villageIds;

    postApi(ASSIGN_VILLAGES, params)
      .then(
        (res) => {
          setIsReAssignDialogOpen(false);
          fetchProject(true);
        },
        (err) => {
          console.log(err);
        }
      )
      .finally(() => {
        setIsRequestig(false);
      });
  };

  const addVillages = () => {
    setIsRequestig(true);
    let villageIds = [];
    let params = addVillagesData;
    params.project_id = project.id;

    addVillagesData.villages.map((village) => {
      villageIds.push(village.id);
    });

    params.villages = villageIds;

    postApi(ADD_VILLAGES, params)
      .then(
        (res) => {
          setIsAddVillageDialogOpen(false);
          fetchProject(true);
        },
        (err) => {
          console.log(err);
        }
      )
      .finally(() => {
        setIsRequestig(false);
      });
  };

  const addFieldSuperVisor = () => {
    setIsRequestig(true);
    let params = {
      project_id: project.id,
      field_supervisors: [],
    };

    fieldSupervisorsData.forEach((data, idx) => {
      let villagesIds = [];

      if (data.villages.length > 0) {
        villagesIds = data.villages.map(function (obj) {
          return obj.id;
        });
      }

      if (data.id && villagesIds.length > 0) {
        params.field_supervisors.push({
          id: data.id,
          villages: villagesIds,
        });
      }
    });
    postApi(ADD_FIELD_SUPER_VISOR, params)
      .then(
        (res) => {
          setIsAddFieldSuperVisorDialogOpen(false);
          fetchProject(true, true);
        },
        (err) => {
          console.log(err);
        }
      )
      .finally(() => {
        setIsRequestig(false);
      });
  };

  const openFieldSuperVisorPopup = (project) => {
    if (usersList.length == 0) {
      Toaster.showWarning("No Field Supervisor left.");
      return;
    }
    getTeams();
    setIsAddFieldSuperVisorDialogOpen(true);
    setInitialFieldSuperVisorData();
  };

  const renderFieldSuperVisorFields = (fieldSupervisor, idx) => {
    const dynamicUserList = getDynamicUserList(
      usersList,
      fieldSupervisorsData,
      fieldSupervisorsData[idx].id
    );

    const dynamicVillageList = getDynamicVillageList(
      villagesList,
      fieldSupervisorsData,
      fieldSupervisorsData[idx].villages
    );

    return (
      <GridContainer key={idx}>
        <GridItem xs={12} sm={12} md={4}>
          <FormControl
            variant="outlined"
            className={`${classes.formControl}, ${classes.singleSelectAddField} `}
          >
            <InputLabel id="field-superVisor-select-outlined-label">
              Field Supervisor
            </InputLabel>
            <Select
              labelId="field-superVisor-select-outlined-label"
              id="field-superVisor-select-outlined"
              name="field_supervisor"
              value={fieldSupervisorsData[idx].id}
              onChange={(e) => handleUserChange(e, idx)}
              label="Field Supervisor"
            >
              {dynamicUserList.map((user, idx) => (
                <MenuItem key={idx} value={user.id}>
                  {user.name}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </GridItem>

        {/* <GridItem xs={12} sm={12} md={4}>
          <FormControl
            variant="outlined"
            className={`${classes.formControl}, ${classes.singleSelectNormalWidth}`}
          >
            <InputLabel id="sub-district-add-field-super-visor-select-outlined-label">
              Sub District
            </InputLabel>
            <Select
              labelId="sub-district-add-field-super-visor-select-outlined-label"
              id="sub-district-add-field-superVisor-select-outlined"
              name="sub_district_id"
              value={fieldSupervisorsData[idx].sub_district_id}
              onChange={(e) =>
                handleAddFieldSuperVisorSubDistrictChange(e, idx)
              }
              label="Sub District"
            >
              {subDistrictList.map((district, idx) => (
                <MenuItem key={idx} value={district.id}>
                  {district.name}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </GridItem> */}
        <GridItem xs={12} sm={12} md={4}>
          <Multiselect
            placeholder="Select Sub District"
            displayValue="name"
            style={multiselectStyle}
            options={subDistrictList}
            onSelect={(selectedList) => selectSubDistrict(selectedList)}
            onRemove={(selectedList) => selectSubDistrict(selectedList)}
          />
        </GridItem>

        <GridItem xs={12} sm={12} md={3}>
          <Multiselect
            className={`${
              fieldSupervisorsData[idx].disable ? classes.disable : ""
            }`}
            options={dynamicVillageList}
            selectedValues={fieldSupervisorsData[idx].villages}
            onSelect={(selectedList, selectedItem) =>
              handleVillagesChange(selectedList, idx)
            }
            placeholder="Select Villages"
            style={multiselectStyle}
            onRemove={(selectedList, removedItem) =>
              handleVillagesChange(selectedList, idx)
            }
            displayValue="name"
          />
        </GridItem>

        <GridItem xs={12} sm={12} md={1}>
          {fieldSupervisorsData.length == idx + 1 &&
            (dynamicUserList.length > 0 || dynamicVillageList.length > 0) &&
            usersList.length > fieldSupervisorsData.length && (
              <IconButton
                edge="end"
                aria-label="delete"
                className={classes.marginTop25}
                onClick={() => addRemoveFieldFromFieldSuperVisorData("add")}
              >
                <Icon>add_circle</Icon>
              </IconButton>
            )}
          {fieldSupervisorsData.length != idx + 1 && (
            <IconButton
              edge="end"
              aria-label="delete"
              className={classes.marginTop25}
              onClick={() =>
                addRemoveFieldFromFieldSuperVisorData("remove", idx)
              }
            >
              <RemoveIcon />
            </IconButton>
          )}
        </GridItem>
      </GridContainer>
    );
  };

  const openReassignDailog = () => {
    let fieldSupervisor = project.field_supervisors[0];
    setIsReAssignDialogOpen(true);
    setReassignVillagesData({
      project_id: "",
      field_supervisor_id: "",
      villages: [],
    });
    setSelectedFieldSuperVisor(fieldSupervisor);
  };

  const openAddVillageDailog = () => {
    let fieldSupervisor = project.field_supervisors[0];
    setIsAddVillageDialogOpen(true);

    setSelectedFieldSuperVisor(fieldSupervisor);

    setAddVillageData({
      field_supervisor_id: fieldSupervisor.user_id,
      villages: [],
      project_id: "",
      sub_district_id: "",
    });
  };

  const handleReassignUserChange = (e) => {
    setReassignVillagesData({
      ...reassignVillagesData,
      field_supervisor_id: "",
      villages: [],
    });

    let fieldSupervisor = project.field_supervisors.find((fieldSupervisor) => {
      return fieldSupervisor.user_id == e.target.value;
    });

    setSelectedFieldSuperVisor(fieldSupervisor);
  };

  const renderReassignDailogContent = () => {
    let filteredFieldSupervisorUserList = [];
    let fieldSupervisorUserList = [];

    if (project && project.field_supervisors.length > 0) {
      project.field_supervisors.map((user) => {
        if (user.user_details.id != selectedFieldSuperVisor.user_id) {
          filteredFieldSupervisorUserList.push(user.user_details);
        }
        fieldSupervisorUserList.push(user.user_details);
      });
    }

    let fieldSupervisorVillages = [];

    if (
      selectedFieldSuperVisor &&
      selectedFieldSuperVisor.villages &&
      selectedFieldSuperVisor.villages.length > 0
    ) {
      selectedFieldSuperVisor.villages.map((village, idx) => {
        if (village.status != "completed")
          fieldSupervisorVillages.push(village.village);
      });
    }

    return (
      <GridContainer>
        <GridItem xs={12} sm={12} md={6}>
          <FormControl
            variant="outlined"
            className={(classes.formControl, classes.singleSelect)}
          >
            <InputLabel id="reassing-from-field-superVisor-select-outlined-label">
              Reassign From
            </InputLabel>
            <Select
              labelId="reassing-from-field-superVisor-select-outlined-label"
              id="reassing-from-field-superVisor-select-outlined"
              value={selectedFieldSuperVisor.user_id}
              onChange={(e) => handleReassignUserChange(e)}
              label="Field Supervisor"
            >
              {fieldSupervisorUserList.map((user, idx) => (
                <MenuItem key={idx} value={user.id}>
                  {user.name}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </GridItem>

        <GridItem xs={12} sm={12} md={6}>
          <FormControl
            variant="outlined"
            className={(classes.formControl, classes.singleSelect)}
          >
            <InputLabel id="reassign-to-field-superVisor-select-outlined-label">
              Reassign To
            </InputLabel>
            <Select
              labelId="reassign-to-field-superVisor-select-outlined-label"
              id="reassing-to-field-superVisor-select-outlined"
              value={reassignVillagesData.field_supervisor_id}
              onChange={(e) =>
                setReassignVillagesData({
                  ...reassignVillagesData,
                  field_supervisor_id: e.target.value,
                })
              }
              label="Field Supervisor"
            >
              {filteredFieldSupervisorUserList.map((user, idx) => (
                <MenuItem key={idx} value={user.id}>
                  {user.name}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </GridItem>

        <GridItem xs={12} sm={12} md={12}>
          <Multiselect
            options={fieldSupervisorVillages}
            selectedValues={reassignVillagesData.villages}
            onSelect={(selectedList, selectedItem) =>
              setReassignVillagesData({
                ...reassignVillagesData,
                villages: selectedList,
              })
            }
            placeholder="Select Villages"
            style={multiselectStyle}
            onRemove={(selectedList, removedItem) =>
              setReassignVillagesData({
                ...reassignVillagesData,
                villages: selectedList,
              })
            }
            displayValue="name"
          />
        </GridItem>
      </GridContainer>
    );
  };

  const handleSubDistrictChange = (e) => {
    setAddVillageData({
      ...addVillagesData,
      sub_district_id: e.target.value,
    });

    getVillages(project.district_id, e.target.value);
  };

  const renderAddVillageDailogContent = () => {
    let fieldSupervisorUserList = [];

    if (project && project.field_supervisors.length > 0) {
      project.field_supervisors.map((user) => {
        fieldSupervisorUserList.push(user.user_details);
      });
    }

    const dynamicVillageList = getDynamicVillageList(
      villagesList,
      [],
      addVillagesData.villages
    );

    return (
      <GridContainer>
        <GridItem xs={12} sm={12} md={12}>
          <FormControl
            variant="outlined"
            className={`${classes.formControl}, ${classes.singleSelectAddField}, ${classes.fullWidth}`}
          >
            <InputLabel id="add-villages-from-field-superVisor-select-outlined-label">
              Field Supervisor
            </InputLabel>
            <Select
              labelId="add-villages-from-field-superVisor-select-outlined-label"
              id="add-villages-from-field-superVisor-select-outlined"
              value={addVillagesData.field_supervisor_id}
              onChange={(e) =>
                setAddVillageData({
                  ...addVillagesData,
                  field_supervisor_id: e.target.value,
                })
              }
              label="Field Supervisor"
            >
              {fieldSupervisorUserList.map((user, idx) => (
                <MenuItem key={idx} value={user.id}>
                  {user.name}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </GridItem>

        {/* <GridItem xs={12} sm={12} md={12}>
          <FormControl
            variant="outlined"
            className={`${classes.formControl}, ${classes.singleSelectAddField}`}
          >
            <InputLabel id="add-villages-sub_district-from-field-superVisor-select-outlined-label">
              Sub District
            </InputLabel>
            <Select
              labelId="add-villages-sub_district-from-field-superVisor-select-outlined-label"
              id="add-villages-sub_district-superVisor-select-outlined"
              value={addVillagesData.sub_district_id}
              onChange={(e) => handleSubDistrictChange(e)}
              label="Sub District"
            >
              {subDistrictList.map((district, idx) => (
                <MenuItem key={idx} value={district.id}>
                  {district.name}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </GridItem> */}
        <GridItem xs={12} sm={12} md={12}>
          <Multiselect
            placeholder="Select Sub District"
            displayValue="name"
            style={multiselectStyle}
            options={subDistrictList}
            onSelect={(selectedList) => selectSubDistrict(selectedList)}
            onRemove={(selectedList) => selectSubDistrict(selectedList)}
          />
        </GridItem>

        <GridItem xs={12} sm={12} md={12}>
          <Multiselect
            options={dynamicVillageList}
            selectedValues={addVillagesData.villages}
            onSelect={(selectedList, selectedItem) =>
              setAddVillageData({ ...addVillagesData, villages: selectedList })
            }
            placeholder="Select Villages"
            style={multiselectStyle}
            onRemove={(selectedList, removedItem) =>
              setAddVillageData({ ...addVillagesData, villages: selectedList })
            }
            displayValue="name"
          />
        </GridItem>
      </GridContainer>
    );
  };

  const renderAssignSectorOfficerDailogContent = () => {
    let sectorOfficerList = [];
    let copiedSectorOfficerList = JSON.parse(
      JSON.stringify(assignFieldOfficerData.sectorOfficerList)
    );

    if (project && project.sector_officers.length > 0) {
      project.sector_officers.forEach((user) => {
        copiedSectorOfficerList.forEach((sectorOfficer, idx) => {
          if (sectorOfficer.id == user.sector_officer_id) {
            copiedSectorOfficerList.splice(idx, 1);
          }
        });
      });
    }

    sectorOfficerList = copiedSectorOfficerList;

    return (
      <GridContainer>
        <GridItem xs={12} sm={12} md={12}>
          <Multiselect
            options={sectorOfficerList}
            selectedValues={assignFieldOfficerData.sector_officers}
            onSelect={(selectedList, selectedItem) =>
              setAssignFieldOfficerData({
                ...assignFieldOfficerData,
                sector_officers: selectedList,
              })
            }
            placeholder="Select User"
            style={multiselectStyleWithWidth}
            onRemove={(selectedList, removedItem) =>
              setAssignFieldOfficerData({
                ...assignFieldOfficerData,
                sector_officers: selectedList,
              })
            }
            displayValue="name"
          />
        </GridItem>
      </GridContainer>
    );
  };

  const renderProject = () => {
    return (
      <div className={classes.demo}>
        <div className={classes.colorBox}>
          <span
            className={`${classes.coloInnexBox} ${classes.completed}`}
          ></span>
          <span className={classes.colorLabel}>Complete</span>

          <span className={`${classes.coloInnexBox} ${classes.pending}`}></span>
          <span className={classes.colorLabel}>Pending</span>

          <span
            className={`${classes.coloInnexBox} ${classes.inprocess}`}
          ></span>
          <span className={classes.colorLabel}>In Process</span>
        </div>
        <Table>
          <TableBody>
            <TableRow>
              <TableCell
                className={`${classes.label} ${classes.upperTableWidth}`}
              >
                Name:
              </TableCell>
              <TableCell className={classes.value}>{project.name}</TableCell>
            </TableRow>

            <TableRow>
              <TableCell
                className={`${classes.label} ${classes.upperTableWidth}`}
              >
                District name:
              </TableCell>
              <TableCell className={classes.value}>
                {project?.project_district
                  ? project.project_district
                      ?.map((projectDistrict) => projectDistrict.district.name)
                      .join(", ")
                  : "--"}
              </TableCell>
            </TableRow>

            <TableRow>
              <TableCell
                className={`${classes.label} ${classes.upperTableWidth}`}
              >
                Crop name:
              </TableCell>
              <TableCell className={classes.value}>
                {project.crop_name}
              </TableCell>
            </TableRow>

            {/* <TableRow>
              <TableCell
                className={`${classes.label} ${classes.upperTableWidth}`}
              >
                Start Date:
              </TableCell>
              <TableCell className={classes.value}>
                {moment(project.start_date).format(
                  DATE_FORMATS.DATE_ONLY_FORMAT
                ) || "--"}
              </TableCell>
            </TableRow> */}

            <TableRow>
              <TableCell
                className={`${classes.label} ${classes.upperTableWidth}`}
              >
                End Date:
              </TableCell>
              <TableCell className={classes.value}>
                {moment(project.end_date).format(
                  DATE_FORMATS.DATE_ONLY_FORMAT
                ) || "--"}
              </TableCell>
            </TableRow>

            <TableRow>
              <TableCell
                className={`${classes.label} ${classes.upperTableWidth}`}
              >
                Target in tonnes:
              </TableCell>
              <TableCell className={classes.value}>
                {project.target_in_tonnes || "--"}
              </TableCell>
            </TableRow>
          </TableBody>
        </Table>
        {project.field_supervisors.length > 0 && (
          <Divider className={classes.marginTop25} />
        )}
        <div className={classes.marginTop25}>
          {project.field_supervisors.length > 0 && (
            <GridContainer>
              <GridItem xs={12} sm={12} md={12}>
                <h3 className={classes.fieldSupervisorsTitle}>
                  Field Supervisors
                </h3>
                <div className={classes.floatRight}>
                  <Button
                    onClick={() => openReassignDailog()}
                    color="primary"
                    className={classes.fieldSuperVisorButton}
                    variant="outlined"
                  >
                    reassign
                  </Button>
                  <Button
                    onClick={() => openAddVillageDailog()}
                    className={classes.fieldSuperVisorButton}
                    variant="outlined"
                  >
                    Assign more
                  </Button>
                </div>
              </GridItem>
            </GridContainer>
          )}
          <TableContainer
            component={Paper}
            className={classes.tableMainContainer}
          >
            <Table className={classes.table} aria-label="caption table">
              <TableHead>
                <TableRow>
                  {project.field_supervisors.map((fieldSupervisor, idx) => (
                    <TableCell className={classes.tableData} key={idx}>
                      {fieldSupervisor.user_details.name}
                    </TableCell>
                  ))}
                </TableRow>
              </TableHead>
              <TableBody>
                {project.maxVillage.map((obj, key) => (
                  <TableRow key={key}>
                    {project.field_supervisors.map((user, userIdx) => {
                      const village = user.field_supervisors_villages[key];
                      return (
                        <TableCell
                          key={userIdx}
                          onClick={() =>
                            history.push(
                              "/admin/farmer/" +
                                project.id +
                                "/team" +
                                "/" +
                                village.village_id
                            )
                          }
                          className={`${classes.tableData} ${classes.cursorPointer}`}
                        >
                          <span
                            className={`${classes.coloInnexBox} ${
                              classes[village.status]
                            }`}
                          ></span>
                          <span className={classes.value}>
                            {village && village.village
                              ? village.village.name
                              : "--"}
                          </span>
                        </TableCell>
                      );
                    })}
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </div>
      </div>
    );
  };

  return (
    <div className={classes.root}>
      <Loader isLoading={isRequesting} />
      <GridContainer>
        <GridItem xs={12} sm={12} md={12}>
          <Grid
            container
            direction="row"
            justify="space-between"
            alignItems="center"
          >
            <Typography variant="h6" className={classes.title}>
              Project Detail
            </Typography>
            <div>
              <Button
                variant="contained"
                color="primary"
                onClick={() => openAssignSectorOfficerDailoge()}
                className={classes.button}
                endIcon={<CreateIcon />}
              >
                Assign Sector officer
              </Button>
              {project && project.sector_officers.length > 0 && (
                <Button
                  variant="contained"
                  color="primary"
                  onClick={() =>
                    setViewSectorOfficerData({
                      ...viewSectorOfficerData,
                      isDialogOpen: true,
                    })
                  }
                  className={`${classes.button} ${classes.marginLeft}`}
                  endIcon={<VisibilityIcon />}
                >
                  View Sector officer
                </Button>
              )}
              {project && (
                <Button
                  variant="contained"
                  color="primary"
                  onClick={() =>
                    history.push("/admin/project/operations/" + project.id)
                  }
                  className={`${classes.button} ${classes.marginLeft}`}
                  endIcon={<CreateIcon />}
                >
                  Edit project
                </Button>
              )}
              {project && (
                <Button
                  variant="contained"
                  color="primary"
                  onClick={() => openFieldSuperVisorPopup(project)}
                  className={`${classes.button} ${classes.marginLeft}`}
                  endIcon={<Icon>add_circle</Icon>}
                >
                  Add Field Supervisor
                </Button>
              )}
            </div>
          </Grid>
          {project ? renderProject() : null}
        </GridItem>
      </GridContainer>
      <Dialog
        maxWidth={"lg"}
        fullWidth={true}
        open={isAddFieldSuperVisorDialogOpen}
        onClose={closeFieldSuperVisorDailogBox}
        aria-labelledby="add-super-visor-dialog-title"
        TransitionComponent={Transition}
      >
        <DialogTitle id="add-super-visor-dialog-title">
          ADD FIELD SUPERVISOR
        </DialogTitle>
        <DialogContent>
          {fieldSupervisorsData.map((fieldSupervisor, idx) =>
            renderFieldSuperVisorFields(fieldSupervisor, idx)
          )}
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => closeFieldSuperVisorDailogBox("close")}
            color="primary"
          >
            Cancel
          </Button>
          <Button
            onClick={() => closeFieldSuperVisorDailogBox("add")}
            color="primary"
          >
            ADD
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog
        TransitionComponent={Transition}
        open={isReAssignDialogOpen}
        onClose={closeReassginDailogBox}
        aria-labelledby="reassign-super-visor-dialog-title"
      >
        <DialogTitle id="reassign-super-visor-dialog-title">
          RE ASSIGN VILLAGES
        </DialogTitle>
        <DialogContent>{renderReassignDailogContent()}</DialogContent>
        <DialogActions>
          <Button
            onClick={() => closeReassginDailogBox("close")}
            color="primary"
          >
            Cancel
          </Button>
          <Button onClick={() => closeReassginDailogBox("add")} color="primary">
            REASSIGN
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog
        TransitionComponent={Transition}
        open={isAddVillageDialogOpen}
        onClose={closeAddVillageDailogBox}
        aria-labelledby="add-village-super-visor-dialog-title"
      >
        <DialogTitle id="add-village-super-visor-dialog-title">
          ADD VILLAGES
        </DialogTitle>
        <DialogContent>{renderAddVillageDailogContent()}</DialogContent>
        <DialogActions>
          <Button
            onClick={() => closeAddVillageDailogBox("close")}
            color="primary"
          >
            Cancel
          </Button>
          <Button
            onClick={() => closeAddVillageDailogBox("add")}
            color="primary"
          >
            ADD
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog
        open={confirmDailogeBoxData.isOpen}
        aria-labelledby="confirm-box-dialog-title"
        aria-describedby="confirm-box-dialog-description"
      >
        <DialogTitle id="confirm-box-dialog-title">
          {"Are you sure?"}
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="confirm-box-dialog-description">
            This will delete you selected field supervior
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => handleConfirmDailogBoxClose("cancel")}
            color="primary"
          >
            Cancel
          </Button>
          <Button
            onClick={() => handleConfirmDailogBoxClose("delete")}
            color="primary"
            autoFocus
          >
            Delete
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog
        TransitionComponent={Transition}
        open={assignFieldOfficerData.isDialogOpen}
        aria-labelledby="rassign-sector-officer-dialog-title"
      >
        <DialogTitle id="rassign-sector-officer-dialog-title">
          ASSIGN SECTOR OFFICER
        </DialogTitle>
        <DialogContent>
          {renderAssignSectorOfficerDailogContent()}
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => closeAssignSectorOfficerDailogBox("close")}
            color="primary"
          >
            Cancel
          </Button>
          <Button
            onClick={() => closeAssignSectorOfficerDailogBox("add")}
            color="primary"
          >
            ASSIGN
          </Button>
        </DialogActions>
      </Dialog>
      <ViewSectorOfficer
        sectorOfiicer={viewSectorOfficerData}
        onUpdate={closeViewSectorOfficerDailog}
      />
    </div>
  );
}
